module.exports = __webpack_public_path__ + "static/media/biometrics.bd430887.png";